/**
 * SearchingAnimation Component
 * Main loading animation with orb and rotating messages
 */

import React, { useEffect, useState } from 'react';
import { PulsingOrb } from './PulsingOrb';
import { ProgressSteps } from './ProgressSteps';
import './loading.css';

const MESSAGES = [
  'Buscando información...',
  'Analizando fuentes...',
  'Preparando resultados...',
];

const MESSAGE_DURATION = 2000; // 2 seconds per message

export const SearchingAnimation: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % MESSAGES.length);
    }, MESSAGE_DURATION);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ai360-searching-animation">
      <div className="ai360-searching-animation-content">
        <PulsingOrb />
        
        <div className="ai360-searching-message">
          <svg 
            className="ai360-searching-icon" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <span className="ai360-searching-text">
            {MESSAGES[currentMessageIndex]}
          </span>
        </div>

        <ProgressSteps />
      </div>
    </div>
  );
};
